import { getReviewSummary } from '@/service/branch'
import { ReviewSummarySource, ReviewSummaryType } from '@/constants/reviewSummary'

export function useReviewSummary(bid: MaybeRef<number | string>) {
  const nuxtApp = useNuxtApp()

  const { data: reviewSummaryData, status } = useAsyncData(`review-summary-${unref(bid)}`, async () => {
    const bidValue = unref(bid)
    if (!bidValue) return null
    try {
      const res = await getReviewSummary(nuxtApp.$axios, bidValue)
      return res.data ?? null
    } catch {
      return null
    }
  })

  const googleAiSummaries = computed(() => reviewSummaryData.value?.summaries?.filter(s => s.source === ReviewSummarySource.GOOGLE_MAPS) ?? [])
  const googleAiHighlights = computed(() => reviewSummaryData.value?.highlights?.filter(h => h.source === ReviewSummarySource.GOOGLE_MAPS) ?? [])
  const funnowAiSummary = computed(
    () => reviewSummaryData.value?.summaries?.find(s => s.source === ReviewSummarySource.FUNNOW && s.type === ReviewSummaryType.OVERVIEW) ?? null
  )

  const hasGoogleAiSummary = computed(() => googleAiSummaries.value.length > 0)
  const hasFunNowAiSummary = computed(() => funnowAiSummary.value !== null)

  const isReady = computed(() => status.value !== 'pending')

  return { googleAiSummaries, googleAiHighlights, funnowAiSummary, hasGoogleAiSummary, hasFunNowAiSummary, isReady }
}
